function Ctrl() {

}

Ctrl.$inject = [
  '$scope'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/directives/sidebar/controller.js